import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type GetStageResponse,
	type UpdateStageInput,
	updateStage,
} from "@/adapters/api";
import { invalidateStageTree, stageKeys } from "../utils/query-keys.ts";
import { useStagesLockedGuard } from "./use-stages-locked-guard.ts";

export function useUpdateStage(constructionId: string | undefined) {
	const queryClient = useQueryClient();
	const guardLocked = useStagesLockedGuard(constructionId);

	return useMutation({
		mutationFn: ({
			stageId,
			input,
		}: {
			stageId: string;
			input: UpdateStageInput;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return updateStage(constructionId, stageId, input);
		},
		onSuccess: (stage, { stageId }) => {
			queryClient.setQueryData<GetStageResponse>(
				stageKeys.detail(constructionId, stageId),
				(old) => old && { ...old, stage },
			);
			return invalidateStageTree(queryClient, constructionId);
		},
		onError: guardLocked,
	});
}
